<template>
  <div>
    <div class="lead">{{$t('question.zeroPool.error')}}</div>
    <!--<p>
      {{$t('question.zeroPool.message')}}
      <router-link :to="{name:'MarketPlace'}">{{($t('offers.list.marketplace')).toLowerCase()}}</router-link>
    </p>-->
    <p v-if="previousQuestionId"><router-link :to="{name:'QuestionShow', params: {id: previousQuestionId}}">
      <font-awesome-icon icon="angle-left"/>&nbsp;{{$t('question.zeroPool.previous')}}</router-link>
    </p>
  </div>

</template>

<script>
  export default {
      props: {
          previousQuestionId: Number||undefined
      }
  }
</script>



// WEBPACK FOOTER //
// src/components/question/ZeroPool.vue